import {makeChart} from "./config";

export default {
  props:{
    data: { type:Object, default: () => null },
    filter: { type:Array, default: () => ([]) }
  },
  data: () => ({
    chart: null,
    isEmpty:false,
  }),
  watch:{
    '$props.data':{
      immediate: true,
      deep: true,
      handler(){
        this.draw()
      }
    },
    '$props.filter':{
      immediate: true,
      deep: true,
      handler(){
        this.draw()
      }
    }
  },
  methods: {
    draw(){
      const isEmpty = this.checkIsEmpty()
      this.isEmpty = isEmpty
      if(isEmpty) return  // 空数据不执行
      this.$nextTick(() => { // 延迟dom渲染后
        if(!this.chart) this.chart = window.echarts.init(this.$refs.chart)
        const data = this.$props.data
        const keys = this.$props.filter
        const config = makeChart(data,keys)

        this.chart.setOption(config,true)
        window.addEventListener('resize',this.setResize)
      })
    },
    checkIsEmpty(){ // 判断是否为空
      const data = this.$props.data
      if(!data) return true // 数据空
      if(!data?.date || data?.date && !data?.date?.length) return true // 时间空
      const filterKeys = this.$props.filter
      const list = filterKeys?.map(ele => data?.[ele]) // Y轴数据空
      return list?.every(ele => !ele?.length)
    },
    setResize(){
      this.chart.resize()
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setResize)
  }
}
